import React from 'react'

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: React.ReactNode
  error?: string
  helperText?: string
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className = '', label, error, helperText, ...props }, ref) => {
    const id = React.useId()

    return (
      <div className="space-y-2">
        {label && (
          <label
            htmlFor={id}
            className="block text-xs font-bold text-text-secondary uppercase tracking-widest"
          >
            {label}
          </label>
        )}
        <textarea
          id={id}
          className={`
            flex min-h-[120px] w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-sm text-white font-medium
            ring-offset-app-bg placeholder:text-text-secondary/50 focus-visible:outline-none focus-visible:ring-2 
            focus-visible:ring-primary/50 focus-visible:border-primary/60 transition-all duration-200 ease-in-out
            hover:border-white/20 hover:bg-white/[0.07]
            disabled:cursor-not-allowed disabled:bg-white/[0.02] disabled:text-text-secondary/50
            ${error ? 'border-error/50 ring-error/30 focus-visible:ring-error/50 focus-visible:border-error/60' : ''}
            ${className}
          `}
          ref={ref}
          {...props}
        />
        {error && (
          <p className="text-sm font-medium text-error flex items-center gap-1.5 animate-in fade-in slide-in-from-top-1 duration-200">
            <span className="w-1 h-1 rounded-full bg-error" />
            {error}
          </p>
        )}
        {helperText && !error && (
          <p className="text-xs text-text-secondary/70">{helperText}</p>
        )}
      </div>
    )
  }
)

Textarea.displayName = 'Textarea'

export { Textarea }
